import { Box } from '@chakra-ui/layout';
import React from 'react';
import { useConfig } from '../hooks/useConfig';

export const BackgroundImage = () => {
  const config = useConfig();
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bgImage={`url("${config?.hero.imgUrl}")`}
      w="100%"
      h="100%"
      zIndex="-1"
      bgSize="cover"
      filter="brightness(50%)"
    />
  );
};
